import { Locale } from "@/i18n/i18n.types";
import { useEnvStore } from "@/store/env.store";
import { EnvActivity, WebEnv } from "@/types/env.types";
import { getCookie } from "@/utils/cookies.utils";

const fetchEnvActivities = async (
  locale: Locale = "en-US",
): Promise<EnvActivity[]> => {
  try {
    const envBase64 = btoa(window.PUBLIC_ENV.HANDSHAKE_ENV || "");
    const response = await fetch(`/v1/env/keywords/${locale}`, {
      headers: {
        Authorization: `Bearer ${envBase64}`,
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch env activities with status: ${response.status}`,
      );
    }
    const parsedResponse = await response.json();
    if (!parsedResponse?.response) {
      throw new Error("Failed to fetch env activities");
    }

    return parsedResponse.response || [];
  } catch (error) {
    throw new Error("Failed to fetch env activities", { cause: error });
  }
};

const fetchWebEnv = async (locale: Locale = "en-US"): Promise<WebEnv> => {
  const envBase64 = btoa(window.PUBLIC_ENV.HANDSHAKE_ENV ?? "");
  try {
    const response = await fetch(`/v1/env/web/${locale}`, {
      headers: {
        Authorization: `Bearer ${envBase64}`,
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch env web with status: ${response.status}`,
      );
    }

    return await response.json();
  } catch (error) {
    throw new Error("Failed to fetch web env", { cause: error });
  }
};

const initWebEnv = async () => {
  const preferredLocale = getCookie("preferred_locale");
  const initialLocale = getCookie("initial_locale");
  const locale = preferredLocale ?? initialLocale ?? "en-US";

  const envWeb = await fetchWebEnv(locale);

  useEnvStore.getState().setWebEnv(envWeb);
};

export { fetchEnvActivities, fetchWebEnv, initWebEnv };
